import React from "react";
import { Box } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import { PieChart } from "@mui/x-charts/PieChart";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#AF19FF"];

/* ---------- Bar‑Chart (Systems) ---------- */
export const SystemsChart = ({ data }: { data: { name: string; count: number }[] }) => (
    <Box sx={{ width: "100%", height: 300 }}>
        <BarChart
            dataset={data}
            xAxis={[{ dataKey: "name", scaleType: "band" }]}
            series={[
                {
                    dataKey: "count",
                    label: "Anzahl Statements",
                    color: "#8884d8",
                },
            ]}
            height={300}
        />
    </Box>
);

/* ---------- Pie‑Chart (Verbs) ---------- */
export const VerbsChart = ({ data }: { data: { name: string; count: number }[] }) => (
    <Box sx={{ width: "100%", height: 300 }}>
        <PieChart
            series={[
                {
                    data: data.map((d) => ({ id: d.name, value: d.count, label: d.name })),
                    colors: COLORS,
                    label: true, // show slice labels
                },
            ]}
            height={300}
        />
    </Box>
);


// TODO weitere charts